module.exports = __webpack_public_path__ + "static/media/ARSelfie.e92b1550.gif";